import { PropsWithChildren, ReactElement, ReactNode, useEffect } from "react";

import flintFavicon from "../../assets/images/FlintLogo.svg";
import wangFavicon from "../../assets/images/HWLogo.svg";
import kokoroFavicon from "../../assets/images/KokoroLogo.png";
import fairpriceFavicon from "../../assets/images/PDD_Favicon.png";
import shabudayFavicon from "../../assets/images/ShabuDaysHeaderLogo.png";
import torikizokuFavicon from "../../assets/images/TorikizokuLogo.png";
import { injectFavicon } from "../../common/helpers/injectFavIcon";
import { Nullable } from "../../common/types/types";
import { IStallMode } from "../../contexts/ConfigContext/types";

const THEME_PREFIX = "theme-";

const FAVICONS = {
	[IStallMode.FAIRPRICE]: fairpriceFavicon,
	[IStallMode.WANG]: wangFavicon,
	[IStallMode.FLINT]: flintFavicon,
	[IStallMode.SHABUDAY]: shabudayFavicon,
	[IStallMode.KOKORO]: kokoroFavicon,
	[IStallMode.TORIKIZOKU]: torikizokuFavicon,
};

interface IConditionThemeProps {
	currentTheme?: Nullable<IStallMode>;
	children: ReactNode;
}

const ConditionTheme = ({
	currentTheme,
	children,
}: PropsWithChildren<IConditionThemeProps>): ReactElement => {
	useEffect(() => {
		if (currentTheme) {
			injectFavicon(FAVICONS[currentTheme]);
		}

		const body = document.body;
		const allThemeClasses = Object.values(IStallMode).map((mode) => `${THEME_PREFIX}${mode}`);

		// Remove any existing theme classes
		body.classList.remove(...allThemeClasses);

		// Add the current theme class if specified
		if (currentTheme) {
			body.classList.add(`${THEME_PREFIX}${currentTheme}`);
		}

		// Cleanup function to remove theme classes when component unmounts
		return () => {
			body.classList.remove(...allThemeClasses);
		};
	}, [currentTheme]);

	const themeClass = currentTheme ? THEME_PREFIX + currentTheme : "";
	const className = `theme-wrapper ${themeClass}`.trim();

	return <div className={className}>{children}</div>;
};

export default ConditionTheme;
